(ns common.db.context
  (:require [camel-snake-kebab.core :refer [->kebab-case]]
            [camel-snake-kebab.extras :refer [transform-keys]]
            [common.url :as url]
            [re-frame.core :as rf]))

(rf/reg-event-db :context/set
  (fn [db [_ new-path-context new-query-context]]
    (let [query-string (.getQuery (url/current-uri))
          context+query-params (merge (url/query-string->map query-string) new-path-context new-query-context)]
      (assoc db :context context+query-params))))

(rf/reg-sub :context
  (fn [db _]
    (:context db)))

(rf/reg-sub :context/select-keys
  :<- [:context]
  (fn [context [_ keywords]]
    (select-keys context keywords)))

(rf/reg-sub :url-context
  :<- [:context]
  :<- [:config]
  (fn [[context config] _]
    (when (seq config)
      (merge context (transform-keys ->kebab-case config)))))

(rf/reg-sub :context/advertiser-id
  :<- [:context]
  (fn [context _]
    (:advertiser-id context)))

(defn advertiser-id [db]
  (get-in db [:context :advertiser-id]))
